/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { Link } from "react-router-dom";

import { ReactComponent as Fill } from "../../../../assets/InvitationSystem/Fill.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/InvitationSystem/DeleteIcon.svg";
import { ReactComponent as WarningCircle } from "../../../../assets/InvitationSystem/WarningCircle.svg";
import { ReactComponent as CheckCircle } from "../../../../assets/InvitationSystem/CheckCircle.svg";

import useLocales from "../../../../hooks/useLocales";

import OgImage from "../../../../assets/landingPages/homePage/Hero.png";
import { Helmet } from "react-helmet";
import useSettings from "../../../../hooks/useSettings";
import { useStateContext } from "../../../../contexts/ThemeContext";
import toast from "react-hot-toast";
import httpRequest from "../../../../axios/index";

const inputClasses =
  "border text-heading_color text-small2 md:text-body_copy2 rounded-md focus:outline-none block w-full p-[13px] py-[5px] px-[15px] md:p-[15px] md:py-[7px]";
const inputErrorClasses =
  "border-state_color_error placeholder:text-state_color_error";
const inputNoErrorClasses =
  "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color";

const InvitionSystemReject = () => {
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const { setActiveInvitionSystemPageNav } = useStateContext();
  const [enteredEmails, setEnteredEmails] = useState([
    "user1@example.com",
    "user2@example.com",
    "user3@example.com",
  ]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const SubmitHandler = async (data) => {
    try {
      const payload = {
        email: data?.email,
      };
      const url = "/api/user/joinWaitingUser";
      const response = await httpRequest.post(url, payload);
      const result = response?.data?.message;
      const status = response?.data?.status;

      if (status === "success") {
        toast.success(result);
      }
      reset();
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>InvitionSystem | Bil.Bio</title>
        <meta property="og:title" content="InvitionSystem | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="bg-light_bg_v4 h-[100vh] overflow-y-auto">
        <div className="flex justify-center">
          <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full">
            <div className="relative px-6 smm:px-8 xsmfold:pt-12 pt-28 py-12">
              <div className="flex md:hidden mt-10 mb-[38px] relative items-center pr-6">
                <div className="absolute inset-y-0 flex items-center justify-center">
                  <Link to={"/mDashboard"}>
                    <LeftArrow
                      className={`h-[20px] w-[20px] ${
                        themeDirection === "rtl" ? "transform -scale-x-100" : ""
                      }`}
                    />
                  </Link>
                </div>
                <h6 className="w-full text-center text-heading_color text-body_copy1_b">
                  {translate("Invitation_System.invite_friend")}
                </h6>
              </div>
              <div className="hidden mb-[30px] md:flex items-center mt-10 gap-[10px] pl-1">
                <div
                  style={{
                    boxShadow:
                      "0px 0px 10px rgba(217, 217, 217, 0.1), -5px 6px 10px rgba(170, 170, 170, 0.3)",
                  }}
                  className="hidden md:flex justify-center items-center p-[9px] bg-white rounded-lg  "
                >
                  <Fill />
                </div>
                <h6 className="text text-heading_color text-custom_h6">
                  {translate("Invitation_System.invite_friend")}
                </h6>
              </div>
              <div className="w-full bg-white rounded-[10px] md:rounded-[20px] lg:rounded-[30px] p-6 lg:p-[50px] md:mb-[90px]">
                <div className="min-h-[calc(100vh_-_335px)] flex flex-col justify-between overflow-y-scroll">
                  <div>
                    <h6 className="text text-heading_color text-custom_h6">
                      {translate("Invitation_System.invite_friend_cap")}
                    </h6>
                    <p className="text-small3 lg:text-small1 mt-2 lg:mt-2.5 text-font_light_color">
                      {translate("Invitation_System.you_have")}
                      <span className="px-1 text-main_color">2</span>
                      {translate("Invitation_System.credits")} left.
                    </p>
                    <hr className="mt-4 lg:mt-5" />
                    <div>
                      <form
                        onSubmit={handleSubmit((data) => SubmitHandler(data))}
                      >
                        <div>
                          <div className="mt-6 lg:mt-[30px]">
                            <div className="grid gap-5 lg:gap-[30px] mt-6 lg:mt-5 grid-cols-1 lg:grid-cols-2">
                              <div>
                                <label
                                  htmlFor="email"
                                  className="block ms-[15px] mb-2 text-heading_color text-small2 sm:text-body_copy2 "
                                >
                                  {/* Email */}
                                  {translate("email")}
                                </label>
                                <div className="relative">
                                  <input
                                    type="email"
                                    id="email"
                                    {...register("email", {
                                      required: translate(
                                        "descriptions.email_required"
                                      ),
                                      validate: {
                                        maxLength: (v) =>
                                          v.length <= 50 ||
                                          translate(
                                            "front_end_pages.contact.the_email_should_have_less_then_characters"
                                          ),
                                        matchPattern: (v) =>
                                          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                            v
                                          ) ||
                                          translate("descriptions.valid_email"),
                                      },
                                    })}
                                    className={`${inputClasses} ${
                                      errors?.email
                                        ? inputErrorClasses
                                        : inputNoErrorClasses
                                    }`}
                                    placeholder={translate(
                                      "front_end_pages.contact.enter_email"
                                    )}
                                  />
                                </div>
                                {errors?.email && (
                                  <small className="text-state_color_error text-small3">
                                    {errors?.email?.message}
                                  </small>
                                )}
                              </div>
                              <div>
                                <button
                                  type="submit"
                                  className="bg-main_color  lg:mt-9 text-white rounded-full h-12 pt-[7px] pb-[6px] smm:pt-[10px] smm:pb-[9px] sm:pt-[13px] sm:pb-[12px] text-small3_b smm:text-small2_b sm:text-small1_bold sm:w-48 w-full"
                                >
                                  {translate(
                                    "Invitation_System.invite_friend_cap"
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div className="mt-6 lg:mt-[30px]">
                        <div className="w-full flex items-center sm:gap-1.5 gap-2">
                          <div className="shrink-0 w-5 h-5 items-center	justify-center flex">
                            <CheckCircle />
                          </div>
                          <p className="text-sm sm:text-base tracking-[-0.2px] sm:tracking-[-0.3px] text-heading_color font-normal">
                            <span className="pr-1 font-normal sm:font-bold text-main_color tracking-[-0.2px] sm:tracking-[-0.3px] text-sm sm:text-base">
                              3
                            </span>
                            Invites Sent Successfully.
                          </p>
                        </div>
                        <div
                          className={`$ flex w-full flex-wrap items-start content-start sm:gap-1.5 gap-2 mt-1.5`}
                        >
                          {enteredEmails.map((email, index) => (
                            <div
                              key={index}
                              className="w-auto h-auto flex items-start gap-2 px-3 sm:pt-3 sm:pb-2.5 pt-1.5	pb-1 rounded-[20px] border-solid	border border-main_color bg-light_bg_v5"
                            >
                              <p className="text-sm not-italic font-normal tracking-[-0.2px] text-font_light_color">
                                {email}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="mt-6 lg:mt-[30px]">
                        <div className="w-full flex items-center sm:gap-1.5 gap-2">
                          <div className="shrink-0 w-5 h-5 items-center	justify-center flex">
                            <WarningCircle />
                          </div>
                          <p className="text-sm sm:text-base tracking-[-0.2px] sm:tracking-[-0.3px] text-heading_color font-normal">
                            <span className="pr-1 font-normal sm:font-bold text-main_color tracking-[-0.2px] sm:tracking-[-0.3px] text-sm sm:text-base">
                              1
                            </span>
                            Error While Sending Invite.
                          </p>
                        </div>
                        <div
                          className={`$ flex w-full flex-wrap items-start content-start sm:gap-1.5 gap-2 mt-1.5`}
                        >
                          <div className="w-auto h-auto flex items-start gap-2 px-3 sm:pt-3 sm:pb-2.5 pt-1.5	pb-1 rounded-[20px] border-solid	border border-main_color bg-light_bg_v5">
                            <p className="text-sm not-italic font-normal tracking-[-0.2px] text-font_light_color">
                              user1@example.com
                            </p>
                            <div className="shrink-0 w-5 h-5 items-center	justify-center flex">
                              <DeleteIcon />
                            </div>
                          </div>
                          <button
                            type="submit"
                            className="text-main_color pt-[7px] pb-[6px] smm:pt-[10px] smm:pb-[9px] sm:pt-[13px] sm:pb-[12px] text-small3_b smm:text-small2_b sm:text-small1_bold ml-1.5"
                          >
                            RESEND INVITE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvitionSystemReject;
